import React from 'react'
import moment from 'moment'
import { format } from '@cbgms/base/utils/datetime'

interface IClockState {
  date: moment.Moment
}

export class Clock extends React.Component<{}, IClockState> {
  timerId?: number
  state = {
    date: moment()
  }

  componentDidMount() {
    this.timerId = window.setInterval(this.tick, 1000)
  }

  componentWillUnmount() {
    window.clearInterval(this.timerId)
  }

  tick = () => {
    this.setState({ date: moment() })
  }

  render() {
    return (
      <React.Fragment>
        <div className='today'>{this.state.date.format('DD MMMM YYYY')}</div>
        <div className='ml1'>{this.state.date.format(format.fullTime)}</div>
      </React.Fragment>
    )
  }
}

export default Clock
